import { render, staticRenderFns } from "./AppComponent.vue?vue&type=template&id=5703d155&scoped=true"
import script from "./AppComponent.vue?vue&type=script&lang=js"
export * from "./AppComponent.vue?vue&type=script&lang=js"
import style0 from "./AppComponent.vue?vue&type=style&index=0&id=5703d155&prod&lang=scss"
import style1 from "./AppComponent.vue?vue&type=style&index=1&id=5703d155&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5703d155",
  null
  
)

export default component.exports